namespace Matrix.Data {
    export interface DataReportColumnForm {
        Name: Serenity.StringEditor;
        Title: Serenity.StringEditor;
        Visible: Serenity.BooleanEditor;
        DisplayFormat: Serenity.StringEditor;
        Alignment: AlignmentStringEditor;
        Width: Serenity.IntegerEditor;
        FormatterType: Serenity.LookupEditor;
        EditorType: Serenity.LookupEditor;
        FilterOnly: Serenity.BooleanEditor;
        GroupOrder: Serenity.IntegerEditor;
        SummaryType: Serenity.EnumEditor;
    }

    export class DataReportColumnForm extends Serenity.PrefixedContext {
        static formKey = 'Data.DataReportColumn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DataReportColumnForm.init)  {
                DataReportColumnForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = AlignmentStringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.EnumEditor;

                Q.initFormType(DataReportColumnForm, [
                    'Name', w0,
                    'Title', w0,
                    'Visible', w1,
                    'DisplayFormat', w0,
                    'Alignment', w2,
                    'Width', w3,
                    'FormatterType', w4,
                    'EditorType', w4,
                    'FilterOnly', w1,
                    'GroupOrder', w3,
                    'SummaryType', w5
                ]);
            }
        }
    }
}
